import { render, staticRenderFns } from "./Descriptions.vue?vue&type=template&id=32c2441b&scoped=true"
import script from "./Descriptions.vue?vue&type=script&lang=js"
export * from "./Descriptions.vue?vue&type=script&lang=js"
import style0 from "./Descriptions.vue?vue&type=style&index=0&id=32c2441b&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32c2441b",
  null
  
)

export default component.exports